(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bapm-native-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bapm-native-navigation]').forEach((branch) => {
    const timers = new WeakMap();
    branch.addEventListener('click', (event) => {
      if (event.target.closest('[data-bapm-parent-link]')) event.stopPropagation();
      const clickedToggle = event.target.closest('.js-toggle');
      if (clickedToggle) clearTimeout(timers.get(clickedToggle.closest('.child-nav__item--toggle')));
    });
    const desktopHover = window.matchMedia('(min-width: 768px) and (hover: hover)');
    [branch, ...branch.querySelectorAll('[data-bapm-nav-group]')].forEach((level) => {
      const toggle = level.querySelector(':scope > .main-nav__item-content > .js-toggle');
      level.addEventListener('mouseenter', () => {
        if (!desktopHover.matches) return;
        clearTimeout(timers.get(level));
        timers.set(level, setTimeout(() => {
          if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
        }, 140));
      });
      level.addEventListener('mouseleave', () => {
        if (!desktopHover.matches) return;
        clearTimeout(timers.get(level));
        timers.set(level, setTimeout(() => {
          if (toggle.getAttribute('aria-expanded') === 'true') toggle.click();
        }, 220));
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
